

    <div class="sufee-login d-flex align-content-center flex-wrap">
        <div class="container">
            <div class="login-content">
                
                <div class="login-form">
                <div class="login-logo">
                    <a href="index.html">
                        <img class="align-content" src="assets/images/gic-header-logo.png" alt="">
                    </a>
                </div>
                    <form name="login">
                  
                        <div class="form-group">
                            <label>User ID</label>
                            <input type="email" class="form-control" placeholder="User ID" name="userid" [(ngModel)]="username">
                            <span style="font-size: 10px; color: red;" [hidden]="isUsername" id="usernameErr">Enter your username</span>
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" placeholder="Password"  name="pswrd" [(ngModel)]="password">
                            <span style="font-size: 10px; color: red;" [hidden]="isPassword" id="passErr">Enter your password</span>
                        </div>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox"> Remember Me
                            </label>
                            <label class="pull-right">
                                <a  data-toggle="modal" data-target="#exampleModal" (click)="goToFrgtPsw()">Forgotten Password?</a>
                            </label>

                        </div>
                        <button type="submit" class="btn btn-success btn-flat m-b-30 m-t-30 loginbtn" (click)="login()">Sign in</button>
                        <div class="social-login-content float-right">
                            <div class="social-button">
                              <button type="button" class="btn social facebook btn-flat btn-addon mb-3 guestbtn" (click)="goToPd()">Public Dashboard</button>
                              
                            </div>
                        </div>
                   
                    </form>

                
                <a href="{{covidUrl}}" target="_blank" class="gic_covid">
                    <button class="btn btn-primary mt-2 mt-xl-0 waves-effect">GO TO Covid-19 Application</button>
                    </a>
            
                </div>
            </div>
        </div>
    </div>
  
   
     
    <!--<script src="https://cdn.jsdelivr.net/npm/jquery@2.2.4/dist/jquery.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/popper.js@1.14.4/dist/umd/popper.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.1.3/dist/js/bootstrap.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/jquery-match-height@0.7.2/dist/jquery.matchHeight.min.js"></script>
    <script src="assets/js/main.js"></script>-->
   

